import styled from 'styled-components'

import { CircleSelectMark, Pencil, PillButton, TypeStyle } from '@syconium/little-miss-figgy'

import { Label } from '../../../primitives/shared-form-styles'

export const NotePill = styled(PillButton)`
  align-items: center;
  align-self: flex-end;
  display: flex;
  gap: ${o => o.theme.spacing(1)};
  justify-content: center;
  padding: ${o => o.theme.spacing(1.5, 3)};
  text-transform: none;
`

export const PencilIcon = styled(Pencil)`
  font-weight: 100;
`

export const NoteHeader = styled(Label)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${o => o.theme.spacing(2)};
`

export const CloseNoteButton = styled.button`
  align-items: center;
  display: flex;

  &:focus-visible {
    outline: 2px solid ${o => o.theme.color.effect.focus.outline.on.background};
    outline-offset: 2px;
  }
`

export const CloseIcon = styled(CircleSelectMark)`
  cursor: pointer;
`

export const NoteTextArea = styled.textarea`
  ${TypeStyle.css.bodyDefault}
  border: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.strong};
  border-radius: ${o => o.theme.borderRadius.sm};
  box-sizing: border-box;
  height: ${o => o.theme.spacing(40)};
  line-height: 22px;
  padding: ${o => o.theme.spacing(2.5, 4)};
  resize: vertical;
  width: 100%;

  /* Safari on iOS zooms the page for anything under 16px, which strands the modal off-screen. */
  &:focus {
    @supports (-webkit-touch-callout: none) {
      font-size: 16px;
    }
  }
`
